import { httpGet } from "./helpers";

export default {
    getConfig: () => httpGet(`${location.origin}/config/config.json`, { disableAuthStore: true})
};